import { createFeatureSelector, createSelector } from "@ngrx/store";
import { GroupState, GROUPS_STATE_NAME } from "./groups.state";


export const selectGroupState = createFeatureSelector<GroupState>(GROUPS_STATE_NAME);

export const setGroup = createSelector(selectGroupState, (form: GroupState) => form.groups);
